import { render, staticRenderFns } from "./BrandHealthOwnedEarned.vue?vue&type=template&id=5dfc8ec6&"
import script from "./BrandHealthOwnedEarned.vue?vue&type=script&lang=js&"
export * from "./BrandHealthOwnedEarned.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports